import React from 'react';
import './Profile.css';
import ApprovalList from './components/ApprovalList';
import UserInfo from './components/UserInfo';
import CompanyList from './components/CompanyList';

export default function Profile() {
  return (
    <div className="profile-container">
      <div className="profile-top-section">
        <ApprovalList />
        <UserInfo />
      </div>
      <CompanyList />
    </div>
  );
}
